import menu from './util/menu.js'
import arrayUtil from './util/ArrayUtil.js'

function objectEmpty(obj){
  for(let x in obj){
    obj[x] = ''
  }
}

export default{
  menu,arrayUtil,objectEmpty
}



// WEBPACK FOOTER //
// ./src/utils/index.js